/**
 * Alert の右端に置く閉じるボタン (×)。 閉じられる Alert (DismissibleInfoAlert・CsvImportAppliedAlert) で共有する。
 * Alert の本文は `flex="1"` の Box で包み、 このボタンを本文の後ろに置く。
 */
import { useTranslation } from 'react-i18next'

import { Box, Tooltip } from '@enechain/ecloud-designsystem'
import { FaXmarkRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

type Props = {
  onClick: () => void
}

export const AlertDismissButton = ({ onClick }: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    /* proto `.ecl-alert-dismiss` (28px 角 / 透明地 / currentColor /
        margin-left:auto)。 alert 本文とは別の操作なので、 本文の後ろに置いて
        右端へ寄せる。

        [DS差異] ecloud `IconButton` の size は xs=24 / sm=32px で **28px が無い**
        ため、 `height` を直指定せず wrapper 方式を採る (`MultiSelect` の
        `CloseIconButton` が 20px で同じ形を採っている先例)。

        hover のボタン名は DS `Tooltip` だけで出し、 native `title` は付けない
        (UI 辞書 components/tooltip.md「native `title` は使わない」)。 両方あると、 hover で
        黒い tooltip とブラウザの tooltip が 2 つ重なって出る。 */
    <Tooltip content={t('common:action.close')}>
      <Box
        as="button"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        alignSelf="flex-start"
        display="inline-flex"
        width="28px"
        height="28px"
        marginLeft="auto"
        color="currentColor"
        opacity={0.8}
        borderRadius="base"
        _hover={{ opacity: 1, backgroundColor: 'Hover.lowEmphasis' }}
        cursor="pointer"
        aria-label={t('common:action.close')}
        onClick={onClick}
      >
        <FaXmarkRegular boxSize={iconSize.alertDismiss} aria-hidden="true" />
      </Box>
    </Tooltip>
  )
}
